import { ReactElement } from 'react';
import cn from 'classnames';
import style from './HostDetails.module.scss';

interface Props {
  rules: Dict;
}

export default function LocationHostDetails(props: Props): ReactElement {
  const activeRules = props.rules.filter(rule => {
    return rule.status === 'active';
  });

  const workplaceInformation = activeRules.filter(rule => rule.category === 'Workplace information');

  const workplaceRules = props.rules.filter(rule => rule.category === 'Workplace rules');

  const otherRules = activeRules.filter(rule => rule.category === 'Other rules');

  const safetyMeasures = activeRules.filter(rule => rule.category === 'Safety measures');

  return (
    <div className={ style.hostDetails }>
      <div className={ style.column }>
        <h6 className={ style.subtitle }>Workplace information</h6>
        <ul className={ style.list }>
          { workplaceInformation.map((rule, ruleIndex) => {
            return (
              <li
                className={ style.item }
                key={ ruleIndex }
              >
                { rule.text }
              </li>
            ); }
          ) }
        </ul>
      </div>
      <div className={ style.column }>
        <h6 className={ style.subtitle }>Workplace rules</h6>
        <ul className={ style.list }>
          { workplaceRules.map((rule, ruleIndex) => {
            return (
              <li
                className={ cn(style.item, rule.status === 'active' ? style.itemAllowed : style.itemNotAllowed) }
                key={ ruleIndex }
              >
                { rule.text }
              </li>
            ); }
          ) }
        </ul>
        { otherRules.length > 0 && (
          <>
            <h6 className={ style.subtitle }>Other rules</h6>
            <ul className={ style.list }>
              { otherRules.map((rule, ruleIndex) => {
                return (
                  <li
                    className={ style.item }
                    key={ ruleIndex }
                  >
                    { rule.text }
                  </li>
                ); }
              ) }
            </ul>
          </>
        ) }
      </div>
      <div className={ style.column }>
        <h6 className={ style.subtitle }>Safety measures</h6>
        <ul className={ style.list }>
          { safetyMeasures.map((rule, ruleIndex) => {
            return (
              <li
                className={ style.item }
                key={ ruleIndex }
              >
                { rule.text }
              </li>
            ); }
          ) }
        </ul>
      </div>
    </div>
  );
}
